var _excluded = ["if", "then", "else"],
    _excluded2 = ["$ref"],
    _excluded3 = ["allOf"],
    _excluded4 = ["allOf"],
    _excluded5 = ["oneOf", "anyOf"],
    _excluded6 = ["dependencies"],
    _excluded7 = ["oneOf"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import get from 'lodash/get';
import set from 'lodash/set';
import times from 'lodash/times';
import transform from 'lodash/transform';
import merge from 'lodash/merge';
import flattenDeep from 'lodash/flattenDeep';
import uniq from 'lodash/uniq';
import mergeAllOf from 'json-schema-merge-allof';
import { ADDITIONAL_PROPERTIES_KEY, ADDITIONAL_PROPERTY_FLAG, ALL_OF_KEY, ANY_OF_KEY, DEPENDENCIES_KEY, IF_KEY, ITEMS_KEY, ONE_OF_KEY, PROPERTIES_KEY, REF_KEY } from "../constants";
import findSchemaDefinition, { splitKeyElementFromObject } from "../findSchemaDefinition";
import getDiscriminatorFieldFromSchema from "../getDiscriminatorFieldFromSchema";
import guessType from "../guessType";
import isObject from "../isObject";
import mergeSchemas from "../mergeSchemas";
import getFirstMatchingOption from "./getFirstMatchingOption";
import deepEquals from "../deepEquals";
/** Retrieves an expanded schema that has had all of its conditions, additional properties, references and dependencies
 * resolved and merged into the `schema` given a `validator`, `rootSchema` and `rawFormData` that is used to do the
 * potentially recursive resolution.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param [rootSchema={}] - The root schema that will be forwarded to all the APIs
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The schema having its conditions, additional properties, references and dependencies resolved
 */

export default function retrieveSchema(validator, schema) {
  var rootSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rawFormData = arguments.length > 3 ? arguments[3] : undefined;
  var experimental_customMergeAllOf = arguments.length > 4 ? arguments[4] : undefined;
  return retrieveSchemaInternal(validator, schema, rootSchema, rawFormData, undefined, undefined, experimental_customMergeAllOf)[0];
}
/** Resolves a conditional block (if/else/then) by removing the condition and merging the appropriate conditional branch
 * with the rest of the schema. If `expandAllBranches` is true, then the `retrieveSchemaInteral()` results for both
 * conditions will be returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that is used to detect valid schema conditions
 * @param schema - The schema for which resolving a condition is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and
 *          dependencies as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - A list of schemas with the appropriate conditions resolved, possibly with all branches expanded
 */

export function resolveCondition(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  var expression = schema.if,
      then = schema.then,
      otherwise = schema.else,
      resolvedSchemaLessConditional = _objectWithoutProperties(schema, _excluded);

  var conditionValue = validator.isValid(expression, formData || {}, rootSchema);
  var resolvedSchemas = [resolvedSchemaLessConditional];
  var schemas = [];

  if (expandAllBranches) {
    if (then && typeof then !== 'boolean') {
      schemas = schemas.concat(retrieveSchemaInternal(validator, then, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
    }

    if (otherwise && typeof otherwise !== 'boolean') {
      schemas = schemas.concat(retrieveSchemaInternal(validator, otherwise, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
    }
  } else {
    var conditionalSchema = conditionValue ? then : otherwise;

    if (conditionalSchema && typeof conditionalSchema !== 'boolean') {
      schemas = schemas.concat(retrieveSchemaInternal(validator, conditionalSchema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
    }
  }

  if (schemas.length) {
    resolvedSchemas = schemas.map(function (s) {
      return mergeSchemas(resolvedSchemaLessConditional, s);
    });
  }

  return resolvedSchemas.flatMap(function (s) {
    return retrieveSchemaInternal(validator, s, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
  });
}
/** Given a list of lists of allOf, anyOf or oneOf values, create a list of lists of all permutations of the values. The
 * `listOfLists` is expected to be all resolved values of the 1st...nth schemas within an `allOf`, `anyOf` or `oneOf`.
 * From those lists, build a matrix for each `xxxOf` where there is more than one schema for a row in the list of lists.
 *
 * For example:
 * - If there are three xxxOf rows (A, B, C) and they have been resolved such that there is only one A, two B and three
 *   C schemas then:
 *   - The permutation for the first row is `[[A]]`
 *   - The permutations for the second row are `[[A,B1], [A,B2]]`
 *   - The permutations for the third row are `[[A,B1,C1], [A,B1,C2], [A,B1,C3], [A,B2,C1], [A,B2,C2], [A,B2,C3]]`
 *
 * @param listOfLists - The list of lists of elements that represent the allOf, anyOf or oneOf resolved values in order
 * @returns - The list of all permutations of schemas for a set of `xxxOf`s
 */

export function getAllPermutationsOfXxxOf(listOfLists) {
  var allPermutations = listOfLists.reduce(function (permutations, list) {
    // When there are more than one set of schemas for a row, duplicate the set of permutations and add in the values
    if (list.length > 1) {
      return list.flatMap(function (element) {
        return times(permutations.length, function (i) {
          return _toConsumableArray(permutations[i]).concat(element);
        });
      });
    } // Otherwise just push in the single value into the current set of permutations


    permutations.forEach(function (permutation) {
      return permutation.push(list[0]);
    });
    return permutations;
  }, [[]] // Start with an empty list
  );
  return allPermutations;
}
/** Resolves references and dependencies within a schema and its 'allOf' children. Passes the `expandAllBranches` flag
 * down to the `retrieveSchemaInternal()`, `resolveReference()` and `resolveDependencies()` helper calls. If
 * `expandAllBranches` is true, then all possible dependencies and/or allOf branches are returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The list of schemas having its references, dependencies and allOf schemas resolved
 */

export function resolveSchema(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  var updatedSchemas = resolveReference(validator, schema, rootSchema, expandAllBranches, recurseList, formData);

  if (updatedSchemas.length > 1 || updatedSchemas[0] !== schema) {
    // return the updatedSchemas array if it has either multiple schemas within it
    // OR the first schema is not the same as the original schema
    return updatedSchemas;
  }

  if (DEPENDENCIES_KEY in schema) {
    var resolvedSchemas = resolveDependencies(validator, schema, rootSchema, expandAllBranches, recurseList, formData);
    return resolvedSchemas.flatMap(function (s) {
      return retrieveSchemaInternal(validator, s, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
    });
  }

  if (ALL_OF_KEY in schema && Array.isArray(schema.allOf)) {
    var allOfSchemaElements = schema.allOf.map(function (allOfSubschema) {
      return retrieveSchemaInternal(validator, allOfSubschema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
    });
    var allPermutations = getAllPermutationsOfXxxOf(allOfSchemaElements);
    return allPermutations.map(function (permutation) {
      return _objectSpread(_objectSpread({}, schema), {}, {
        allOf: permutation
      });
    });
  } // No $ref or dependencies or allOf attribute was found, returning the original schema.


  return [schema];
}
/** Resolves all references within a schema and then returns the `retrieveSchemaInternal()` if the resolved schema is
 * actually different than the original. Passes the `expandAllBranches` flag down to the `retrieveSchemaInternal()`
 * helper call.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a reference is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The list schemas retrieved after having all references resolved
 */

export function resolveReference(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  var updatedSchema = resolveAllReferences(schema, rootSchema, recurseList);

  if (updatedSchema !== schema) {
    // Only call this if the schema was actually changed by the `resolveAllReferences()` function
    return retrieveSchemaInternal(validator, updatedSchema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
  }

  return [schema];
}
/** Resolves all references within the schema itself as well as any of its properties and array items.
 *
 * @param schema - The schema for which resolving all references is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param recurseList - List of $refs already resolved to prevent recursion
 * @returns - given schema will all references resolved or the original schema if no internal `$refs` were resolved
 */

export function resolveAllReferences(schema, rootSchema, recurseList) {
  if (!isObject(schema)) {
    return schema;
  }

  var resolvedSchema = schema; // resolve top level ref

  if (REF_KEY in resolvedSchema) {
    var _resolvedSchema = resolvedSchema,
        $ref = _resolvedSchema.$ref,
        localSchema = _objectWithoutProperties(_resolvedSchema, _excluded2); // Check for a recursive reference and stop the loop


    if (recurseList.includes($ref)) {
      return resolvedSchema;
    }

    recurseList.push($ref); // Retrieve the referenced schema definition.

    var refSchema = findSchemaDefinition($ref, rootSchema);
    resolvedSchema = _objectSpread(_objectSpread({}, refSchema), localSchema);
  }

  if (PROPERTIES_KEY in resolvedSchema) {
    var childrenLists = [];
    var updatedProps = transform(resolvedSchema[PROPERTIES_KEY], function (result, value, key) {
      var childList = _toConsumableArray(recurseList);

      result[key] = resolveAllReferences(value, rootSchema, childList);
      childrenLists.push(childList);
    }, {});
    merge(recurseList, uniq(flattenDeep(childrenLists)));
    resolvedSchema = _objectSpread(_objectSpread({}, resolvedSchema), {}, _defineProperty({}, PROPERTIES_KEY, updatedProps));
  }

  if (ITEMS_KEY in resolvedSchema && !Array.isArray(resolvedSchema.items) && typeof resolvedSchema.items !== 'boolean') {
    resolvedSchema = _objectSpread(_objectSpread({}, resolvedSchema), {}, {
      items: resolveAllReferences(resolvedSchema.items, rootSchema, recurseList)
    });
  }

  return deepEquals(schema, resolvedSchema) ? schema : resolvedSchema;
}
/** Creates new 'properties' items for each key in the `formData`
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param theSchema - The schema for which the existing additional properties is desired
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s * @param validator
 * @param [aFormData] - The current formData, if any, to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The updated schema with additional properties stubbed
 */

export function stubExistingAdditionalProperties(validator, theSchema, rootSchema, aFormData, experimental_customMergeAllOf) {
  // Clone the schema so that we don't ruin the consumer's original
  var schema = _objectSpread(_objectSpread({}, theSchema), {}, {
    properties: _objectSpread({}, theSchema.properties)
  }); // make sure formData is an object


  var formData = aFormData && isObject(aFormData) ? aFormData : {};
  Object.keys(formData).forEach(function (key) {
    if (key in schema.properties) {
      // No need to stub, our schema already has the property
      return;
    }

    var additionalProperties = {};

    if (typeof schema.additionalProperties !== 'boolean') {
      if (REF_KEY in schema.additionalProperties) {
        additionalProperties = retrieveSchema(validator, {
          $ref: get(schema.additionalProperties, [REF_KEY])
        }, rootSchema, formData, experimental_customMergeAllOf);
      } else if ('type' in schema.additionalProperties) {
        additionalProperties = _objectSpread({}, schema.additionalProperties);
      } else if (ANY_OF_KEY in schema.additionalProperties || ONE_OF_KEY in schema.additionalProperties) {
        additionalProperties = _objectSpread({
          type: 'object'
        }, schema.additionalProperties);
      } else {
        additionalProperties = {
          type: guessType(get(formData, [key]))
        };
      }
    } else {
      additionalProperties = {
        type: guessType(get(formData, [key]))
      };
    } // The type of our new key should match the additionalProperties value;


    schema.properties[key] = additionalProperties; // Set our additional property flag so we know it was dynamically added

    set(schema.properties, [key, ADDITIONAL_PROPERTY_FLAG], true);
  });
  return schema;
}
/** Internal handler that retrieves an expanded schema that has had all of its conditions, additional properties,
 * references and dependencies resolved and merged into the `schema` given a `validator`, `rootSchema` and `rawFormData`
 * that is used to do the potentially recursive resolution. If `expandAllBranches` is true, then all possible branches
 * of the schema and its references, conditions and dependencies are returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
 * @param [expandAllBranches=false] - Flag, if true, will return all possible branches of conditions, any/oneOf and
 *          dependencies as a list of schemas
 * @param [recurseList=[]] - The optional, list of recursive references already processed
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The schema(s) resulting from having its conditions, additional properties, references and dependencies
 *          resolved. Multiple schemas may be returned if `expandAllBranches` is true.
 */

export function retrieveSchemaInternal(validator, schema, rootSchema, rawFormData) {
  var expandAllBranches = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var recurseList = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var experimental_customMergeAllOf = arguments.length > 6 ? arguments[6] : undefined;

  if (!isObject(schema)) {
    return [{}];
  }

  var resolvedSchemas = resolveSchema(validator, schema, rootSchema, expandAllBranches, recurseList, rawFormData, experimental_customMergeAllOf);
  return resolvedSchemas.flatMap(function (s) {
    var _a;

    var resolvedSchema = s;

    if (IF_KEY in resolvedSchema) {
      return resolveCondition(validator, resolvedSchema, rootSchema, expandAllBranches, recurseList, rawFormData, experimental_customMergeAllOf);
    }

    if (ALL_OF_KEY in resolvedSchema) {
      // resolve allOf schemas
      if (expandAllBranches) {
        var _resolvedSchema2 = resolvedSchema,
            allOf = _resolvedSchema2.allOf,
            restOfSchema = _objectWithoutProperties(_resolvedSchema2, _excluded3);

        return [].concat(_toConsumableArray(allOf), [restOfSchema]);
      }

      try {
        var withContainsSchemas = [];
        var withoutContainsSchemas = [];
        (_a = resolvedSchema.allOf) === null || _a === void 0 ? void 0 : _a.forEach(function (s) {
          if (_typeof(s) === 'object' && s.contains) {
            withContainsSchemas.push(s);
          } else {
            withoutContainsSchemas.push(s);
          }
        });

        if (withContainsSchemas.length) {
          resolvedSchema = _objectSpread(_objectSpread({}, resolvedSchema), {}, {
            allOf: withoutContainsSchemas
          });
        }

        resolvedSchema = experimental_customMergeAllOf ? experimental_customMergeAllOf(resolvedSchema) : mergeAllOf(resolvedSchema, {
          deep: false
        });

        if (withContainsSchemas.length) {
          resolvedSchema.allOf = withContainsSchemas;
        }
      } catch (e) {
        console.warn('could not merge subschemas in allOf:\n', e);

        var _resolvedSchema3 = resolvedSchema,
            _allOf = _resolvedSchema3.allOf,
            resolvedSchemaWithoutAllOf = _objectWithoutProperties(_resolvedSchema3, _excluded4);

        return resolvedSchemaWithoutAllOf;
      }
    }

    var hasAdditionalProperties = ADDITIONAL_PROPERTIES_KEY in resolvedSchema && resolvedSchema.additionalProperties !== false;

    if (hasAdditionalProperties) {
      return stubExistingAdditionalProperties(validator, resolvedSchema, rootSchema, rawFormData, experimental_customMergeAllOf);
    }

    return resolvedSchema;
  });
}
/** Resolves an `anyOf` or `oneOf` within a schema (if present) to the list of schemas returned from
 * `retrieveSchemaInternal()` for the best matching option. If `expandAllBranches` is true, then a list of schemas for ALL
 * options are retrieved and returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema, defaults to an empty object
 * @returns - Either an array containing the best matching option or all options if `expandAllBranches` is true
 */

export function resolveAnyOrOneOfSchemas(validator, schema, rootSchema, expandAllBranches, rawFormData) {
  var anyOrOneOf;

  var _schema = schema,
      oneOf = _schema.oneOf,
      anyOf = _schema.anyOf,
      remaining = _objectWithoutProperties(_schema, _excluded5);

  if (Array.isArray(oneOf)) {
    anyOrOneOf = oneOf;
  } else if (Array.isArray(anyOf)) {
    anyOrOneOf = anyOf;
  }

  if (anyOrOneOf) {
    // Ensure that during expand all branches we pass an object rather than undefined so that all options are interrogated
    var formData = rawFormData === undefined && expandAllBranches ? {} : rawFormData;
    var discriminator = getDiscriminatorFieldFromSchema(schema);
    anyOrOneOf = anyOrOneOf.map(function (s) {
      // Due to anyOf/oneOf possibly using the same $ref we always pass a fresh recurse list array so that each option
      // can resolve recursive references independently
      return resolveAllReferences(s, rootSchema, []);
    }); // Call this to trigger the set of isValid() calls that the schema parser will need

    var option = getFirstMatchingOption(validator, formData, anyOrOneOf, rootSchema, discriminator);

    if (expandAllBranches) {
      return anyOrOneOf.map(function (item) {
        return mergeSchemas(remaining, item);
      });
    }

    schema = mergeSchemas(remaining, anyOrOneOf[option]);
  }

  return [schema];
}
/** Resolves dependencies within a schema and its 'anyOf/oneOf' children. Passes the `expandAllBranches` flag down to
 * the `resolveAnyOrOneOfSchema()` and `processDependencies()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a dependency is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The list of schemas with their dependencies resolved
 */

export function resolveDependencies(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  // Drop the dependencies from the source schema.
  var dependencies = schema.dependencies,
      remainingSchema = _objectWithoutProperties(schema, _excluded6);

  var resolvedSchemas = resolveAnyOrOneOfSchemas(validator, remainingSchema, rootSchema, expandAllBranches, formData);
  return resolvedSchemas.flatMap(function (resolvedSchema) {
    return processDependencies(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf);
  });
}
/** Processes all the `dependencies` recursively into the list of `resolvedSchema`s as needed. Passes the
 * `expandAllBranches` flag down to the `withDependentSchema()` and the recursive `processDependencies()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param dependencies - The set of dependencies that needs to be processed
 * @param resolvedSchema - The schema for which processing dependencies is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The schema with the `dependencies` resolved into it
 */

export function processDependencies(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  var schemas = [resolvedSchema]; // Process dependencies updating the local schema properties as appropriate.

  var _loop = function _loop(dependencyKey) {
    // Skip this dependency if its trigger property is not present.
    if (!expandAllBranches && get(formData, [dependencyKey]) === undefined) {
      return "continue";
    } // Skip this dependency if it is not included in the schema (such as when dependencyKey is itself a hidden dependency.)


    if (resolvedSchema.properties && !(dependencyKey in resolvedSchema.properties)) {
      return "continue";
    }

    var _splitKeyElementFromO = splitKeyElementFromObject(dependencyKey, dependencies),
        _splitKeyElementFromO2 = _slicedToArray(_splitKeyElementFromO, 2),
        remainingDependencies = _splitKeyElementFromO2[0],
        dependencyValue = _splitKeyElementFromO2[1];

    if (Array.isArray(dependencyValue)) {
      schemas[0] = withDependentProperties(resolvedSchema, dependencyValue);
    } else if (isObject(dependencyValue)) {
      schemas = withDependentSchema(validator, resolvedSchema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData, experimental_customMergeAllOf);
    }

    return {
      v: schemas.flatMap(function (schema) {
        return processDependencies(validator, remainingDependencies, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf);
      })
    };
  };

  for (var dependencyKey in dependencies) {
    var _ret = _loop(dependencyKey);

    if (_ret === "continue") continue;
    if (_typeof(_ret) === "object") return _ret.v;
  }

  return schemas;
}
/** Updates a schema with additionally required properties added
 *
 * @param schema - The schema for which resolving a dependent properties is desired
 * @param [additionallyRequired] - An optional array of additionally required names
 * @returns - The schema with the additional required values merged in
 */

export function withDependentProperties(schema, additionallyRequired) {
  if (!additionallyRequired) {
    return schema;
  }

  var required = Array.isArray(schema.required) ? Array.from(new Set([].concat(_toConsumableArray(schema.required), _toConsumableArray(additionallyRequired)))) : additionallyRequired;
  return _objectSpread(_objectSpread({}, schema), {}, {
    required: required
  });
}
/** Merges a dependent schema into the `schema` dealing with oneOfs and references. Passes the `expandAllBranches` flag
 * down to the `retrieveSchemaInternal()`, `resolveReference()` and `withExactlyOneSubschema()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a dependent schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param dependencyKey - The key name of the dependency
 * @param dependencyValue - The potentially dependent schema
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData]- The current formData to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The list of schemas with the dependent schema resolved into them
 */

export function withDependentSchema(validator, schema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  var dependentSchemas = retrieveSchemaInternal(validator, dependencyValue, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
  return dependentSchemas.flatMap(function (dependent) {
    var oneOf = dependent.oneOf,
        dependentSchema = _objectWithoutProperties(dependent, _excluded7);

    schema = mergeSchemas(schema, dependentSchema); // Since it does not contain oneOf, we return the original schema.

    if (oneOf === undefined) {
      return schema;
    } // Resolve $refs inside oneOf.


    var resolvedOneOfs = oneOf.map(function (subschema) {
      if (typeof subschema === 'boolean' || !(REF_KEY in subschema)) {
        return [subschema];
      }

      return resolveReference(validator, subschema, rootSchema, expandAllBranches, recurseList, formData);
    });
    var allPermutations = getAllPermutationsOfXxxOf(resolvedOneOfs);
    return allPermutations.flatMap(function (resolvedOneOf) {
      return withExactlyOneSubschema(validator, schema, rootSchema, dependencyKey, resolvedOneOf, expandAllBranches, recurseList, formData, experimental_customMergeAllOf);
    });
  });
}
/** Returns a list of `schema`s with the best choice from the `oneOf` options merged into it. If `expandAllBranches` is
 * true, then a list of schemas for ALL options are retrieved and returned. Passes the `expandAllBranches` flag down to
 * the `retrieveSchemaInternal()` helper call.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used to validate oneOf options
 * @param schema - The schema for which resolving a oneOf subschema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param dependencyKey - The key name of the oneOf dependency
 * @param oneOf - The list of schemas representing the oneOf options
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData to assist retrieving a schema
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - Either an array containing the best matching option or all options if `expandAllBranches` is true
 */

export function withExactlyOneSubschema(validator, schema, rootSchema, dependencyKey, oneOf, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
  var validSubschemas = oneOf.filter(function (subschema) {
    if (typeof subschema === 'boolean' || !subschema || !subschema.properties) {
      return false;
    }

    var conditionPropertySchema = subschema.properties[dependencyKey];

    if (conditionPropertySchema) {
      var conditionSchema = {
        type: 'object',
        properties: _defineProperty({}, dependencyKey, conditionPropertySchema)
      };
      return validator.isValid(conditionSchema, formData, rootSchema) || expandAllBranches;
    }

    return false;
  });

  if (!expandAllBranches && validSubschemas.length !== 1) {
    console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
    return [schema];
  }

  return validSubschemas.flatMap(function (s) {
    var subschema = s;

    var _splitKeyElementFromO3 = splitKeyElementFromObject(dependencyKey, subschema.properties),
        _splitKeyElementFromO4 = _slicedToArray(_splitKeyElementFromO3, 1),
        dependentSubschema = _splitKeyElementFromO4[0];

    var dependentSchema = _objectSpread(_objectSpread({}, subschema), {}, {
      properties: dependentSubschema
    });

    var schemas = retrieveSchemaInternal(validator, dependentSchema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
    return schemas.map(function (s) {
      return mergeSchemas(schema, s);
    });
  });
}